import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { RouteMetadata } from "@/components/site/RouteMetadata";
import { SkyThemeProvider } from "@/theme/SkyThemeProvider";
import { SiteLocaleProvider } from "./SiteLocaleProvider";
import { bootstrapAuthSession, getLandingIdentity } from "@/auth/authSession";
import { afterPaint } from "@/lib/after-paint";

export function RouteFrame() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    const initialize = () => {
      if (getLandingIdentity().kind === "loading") void bootstrapAuthSession();
    };
    if (pathname === "/") return afterPaint(initialize);
    initialize();
  }, [pathname]);

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [hash, pathname]);

  return <SiteLocaleProvider><SkyThemeProvider><RouteMetadata /><Outlet /></SkyThemeProvider></SiteLocaleProvider>;
}
